// <WelcomeBanner> — post-install dismissible banner shown to the appstore
// admin until they dismiss it. Per-tenant, persisted in localStorage.

import { useEffect, useState } from "react";
import { useWorkspace } from "@/workspace";
import "./welcome-banner.css";

const STORAGE_KEY = "reb.welcome-banner.dismissed";

export function WelcomeBanner(): JSX.Element | null {
  const { workspace } = useWorkspace();
  const [dismissed, setDismissed] = useState<boolean>(true);

  useEffect(() => {
    if (!workspace) {
      setDismissed(true);
      return;
    }
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      const set = raw ? new Set<string>(JSON.parse(raw)) : new Set<string>();
      setDismissed(set.has(workspace.tenant_id));
    } catch {
      setDismissed(false);
    }
  }, [workspace]);

  if (!workspace || dismissed) {
    return null;
  }

  function handleDismiss(): void {
    if (!workspace) return;
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      const set = raw ? new Set<string>(JSON.parse(raw)) : new Set<string>();
      set.add(workspace.tenant_id);
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(set)));
    } catch {
      // ignore storage failure; just hide
    }
    setDismissed(true);
  }

  return (
    <div className="reb-welcome-banner" role="status">
      <div>
        <strong>Welcome to your new workspace.</strong>{" "}
        <span>Tour the dashboard, then visit Locations to name your sites.</span>
      </div>
      <button
        type="button"
        className="reb-button"
        onClick={handleDismiss}
        aria-label="Dismiss"
      >
        Dismiss
      </button>
    </div>
  );
}
